import { render, staticRenderFns } from "./Correspondance.vue?vue&type=template&id=360a30bd&scoped=true"
import script from "./Correspondance.vue?vue&type=script&lang=js"
export * from "./Correspondance.vue?vue&type=script&lang=js"
import style0 from "./Correspondance.vue?vue&type=style&index=0&id=360a30bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a30bd",
  null
  
)

export default component.exports